import Vue from 'vue';

import PopupLayer from './components/Common/Popup/PopupLayer.vue';
import UploadApk from './components/Common/UploadApk/UploadApk.vue';
import StickyDoughnut from './components/Common/StickyDoughnut/StickyDoughnut.vue';
import Scheduler from './components/Campaign/Scheduler/Scheduler.vue';
import AppsBudgets from './components/Campaign/AppsBudgets/AppsBudgets.vue';
import AppPublisherCombo from './components/Common/appPublisherCombo.vue';
import AppPublisherComboLogin from './components/Common/AppPublisherComboLogin.vue';

import { routes } from './routes';
import VueRouter from 'vue-router';
import { store } from './store/store.js';

import Vuelidate from 'vuelidate';
import VeeValidate from 'vee-validate';

import appConfig from './appConfig.config';
import loaderModule from './helpers/loaderModule';
import popupModule from './helpers/popupModule';
import googleAnalyticsModule from './helpers/googleAnalytics';

import MenuList from './components/Common/MenuList/MenuList.vue';
import MenuListItem from './components/Common/MenuList/MenuListItem.vue';
import SelfserviceButton from './components/ApproveDashboard/button.vue';
import DatePicker from 'vue2-datepicker';

import axios from 'axios';
import VueFontAwesomeIcon from 'vue-awesome';

Vue.component('menuList', MenuList);
Vue.component('menuListItem', MenuListItem);
Vue.component('icon', VueFontAwesomeIcon);
Vue.component("selfservice-button", SelfserviceButton);
import AppDatePickerField from './components/Common/RangedDatePicker/DatePicker.vue';
import AppDatePickerInput from './components/Common/RangedDatePicker/DatePickerInput.vue';
Vue.component("app-date-picker-field", AppDatePickerField);
Vue.component("app-date-picker-in", AppDatePickerInput);
Vue.component("date-picker", DatePicker);

Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VeeValidate);

Vue.filter('NumberToCurrency', (numberStr) => {
    if (numberStr) {
        const numberToConvert = +(numberStr.replaceAll(',', '').replace('+', ''));
        // Nine Zeroes for Billions
        return Math.abs(numberToConvert) >= 1.0e+9

            ? Math.abs(numberToConvert) / 1.0e+9 + 'B'
            // Six Zeroes for Millions
            : Math.abs(numberToConvert) >= 1.0e+6

                ? Math.abs(numberToConvert) / 1.0e+6 + 'M'
                // Three Zeroes for Thousands
                : Math.abs(numberToConvert) >= 1.0e+3

                    ? Math.abs(numberToConvert) / 1.0e+3 + 'K'

                    : Math.abs(numberToConvert);
    }
    return numberStr;
});

export const router = new VueRouter({
    routes,
    mode: 'history'
});

// installs the loader module
Vue.use(loaderModule);

// installs the popup module
Vue.use(popupModule);

// installs the googleAnalytics module
Vue.use(googleAnalyticsModule, {
    id: 'UA-32241134-1'
});


// main vue instance
axios.install = (Vue, options) => {
    Vue.$http = axios;
    Vue.prototype.http = axios;
};
Vue.use(axios);

if (appConfig.http.baseUrl)
    Vue.$http.defaults.baseURL = appConfig.http.baseUrl;

let instanceConfig = {
    el: '#app',
    router,
    store
};

const route = routes.find((c) => {
    return c.path.toLowerCase() === location.pathname.toLowerCase()
});

if (route && route.path == '/Discovery/Campaign.aspx') {
    instanceConfig.el = '#ca_by_events_vue_app';
}

if (route && route.stores && route.stores.length > 0) {
    route.stores.forEach(store => {
        instanceConfig.store.registerModule("componentStore", store);
    });
}

var __call_counter = 0;
window.callCounter = function () { return __call_counter++; };
window.app = new Vue(instanceConfig);
////

// sets the isAdmin in the store
if (typeof _isAdmin != 'undefined') {
    store.commit('setIsAdmin', _isAdmin);
}
if (typeof _publisherEmail != 'undefined') {
    store.commit('setPublisherEmail', _publisherEmail);
}
if (typeof _publisherCompany != 'undefined') {
    store.commit('setPublisherCompanyName', _publisherCompany);
}

// this vue instance is inside the SelfService.Master page, as the PopupLayer mechanism is global for all the pages
if (document.getElementById('popup-app')) {
    window.appPopUp = new Vue({
        el: '#popup-app',
        store,
        components: {
            popupLayer: PopupLayer
        }
    });
}

if (document.getElementById('uploadApk')) {
    window.UploadApk = new Vue({
        el: '#uploadApk',
        store,
        components: {
            uploadApk: UploadApk
        }
    });
}

// sticky doughnut char for new campaign
if (document.getElementById('stickyDoughnut')) {
    window.appCampaignDoughnut = new Vue({
        el: '#stickyDoughnut',
        store,
        components: {
            stickyDoughnut: StickyDoughnut
        }
    });
}

// scheduler for campaign
if (document.getElementById('scheduler')) {
    window.appScheduler = new Vue({
        el: '#scheduler',
        store,
        components: {
            scheduler: Scheduler
        }
    });
}

if (document.getElementById('appsBudgets')) {
    window.appsBudgetsVue = new Vue({
        el: '#appsBudgets',
        store,
        components: {
            AppsBudgets: AppsBudgets
        }
    });
}

window.Vue = Vue;
window.trackingPostbackUrlToolcomponent = () => import('./components/Tracking/TrackingPostbackUrlTool.vue');

// this vue instance is inside the SelfService.Master page, as the publisher auto-complete Combo is global for all the pages
if (document.getElementById('publisher-combo-app')) {
    new Vue({
        el: '#publisher-combo-app',
        store,
        components: {
            AppPublisherCombo: AppPublisherCombo
        }
    });
}

// this vue instance is inside the Login2.aspx page, as the publisher auto-complete Combo is global for all the pages

if (document.getElementById('publisher-combo-app-login')) {

    let AppPublisherComboLogin = () => import('./components/Common/AppPublisherComboLogin.vue');
    new Vue({
        el: '#publisher-combo-app-login',
        store,
        components: {
            AppPublisherComboLogin: AppPublisherComboLogin
        }
    });
}

if (route && route.path == '/Discovery/Campaign.aspx') {
    if (document.getElementById('campaign-brands-app')) {

        let comp = () => import('./components/Campaign/Targeting/Brands/CampaignBrandsTargeting.vue');
        window.campaignBrands = new Vue({
            el: '#campaign-brands-app',
            store,
            components: {
                CampaignBrandsTargeting: comp
            }
        });
    }

    if (document.getElementById('campaign-langs-app')) {

        let comp = () => import('./components/Campaign/Targeting/Langs/CampaignLangsTargeting.vue');
        window.campaignLangs = new Vue({
            el: '#campaign-langs-app',
            store,
            components: {
                CampaignLangsTargeting: comp
            }
        });
    }
}

// vue instance only for qa server --> tips to use the SELFSERVICE
if (document.getElementById('selfservice-tips')) {
    let comp = () => import('./components/selfserviceTips/selfserviceTips.vue');
    new Vue({
        el: '#selfservice-tips',
        components: {
            AppSelfserviceTips: comp
        }
    });
}

// vue instance for graph in discovery/manage
var __showChartComponent = (typeof g_graphPage !== "undefined") && (g_graphPage == 'manage' || (g_graphPage == 'reports' && g_filterSort.params.reportType == 'Apps'));

if (__showChartComponent == true && document.getElementById('graph-discovery-manage') != null) {

    document.getElementById('graph-discovery-manage').style.display = 'block';

    let comp = () => import('./components/Common/Graph/Graph.vue');

    let graphUrls = {
        getGraphData: {
            manage: '/api/ManageApi/GetGraphData',
            reports: '/api/ReportsApi/GetGraphData'
        }
    }

    document.captureEvents(Event.MOUSEMOVE);
    document.onmouseover = (e) => {
        if (g_reportGraph)
            g_reportGraph.getExternalMouseOverChart(e);
    }

    document.onmousemove = (e) => {
        if (g_reportGraph)
            g_reportGraph.getExternalMouseMove(e);
    }
    
    window.g_reportGraph = new Vue({
        el: '#graph-discovery-manage',
        components: {
            GraphDiscoveryManage: comp
        },
        store,
        data: {
            graphPage: g_graphPage,
            tableData: [],     //  this is an external array from the table. It triggers the getGraphData computed property.
            graphData: [],
            graphDateRange: {},
            graphTypes: [],
            graphAllTypes: ['Installs', 'Impressions', 'Clicks', 'Cost', 'ConversionRate'],
            graphColors: {
                Installs: '#3597e4',
                Reengagements: '#a458c5',
                Impressions: '#f88432',
                Clicks: '#de42ba',
                Cost: '#2ab4ae',
                ConversionRate: '#152AA2',
                Revenue: '#fcb017',
                KPI: '#31afd4'
            },
            all_data: {},
            showGraph: false,
            isDataLoaded: false,
            hasNoGraphData: false,
            reportType: g_filterSort.params.reportType || '',
            dataLength: 0
        },
        methods: {

            getExternalMouseOverChart(event) {

                var pshow = event.target.id == "line-chart";
                if (this.$refs && this.$refs.graphcomp)
                    this.$refs.graphcomp.setShowTooltip(pshow);
                
            },

            getExternalMouseMove(event) {

                var pshow = event.target.id == "line-chart";
                if (this.$refs && this.$refs.graphcomp) {
                    if (this.$refs.graphcomp.showTooltip && pshow) {
                        this.$refs.graphcomp.setMousePosition(event.clientX, event.clientY);
                    }
                }
            },

            onTabClick(selected_types) {
                this.setGraphTypes(selected_types);
            },

            setGraphTypes(selected_types) {
                this.graphTypes = selected_types;
                localStorage.setItem("reportsGraph_graphSelectedTypes", JSON.stringify(this.graphTypes));
            },

            getLocalGraphData() {
                return this.graphData;
            },

            getGraphDateRangeDaysCount(from, to) {
                var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
                var fromDate = new Date(from + " 00:00:00");
                var toDate = new Date(to + " 23:59:59");
                var daysCount = Math.round(Math.abs((toDate.getTime() - fromDate.getTime()) / (oneDay)));
                return daysCount;
            },
            
            fetchGraphData() {

                var that = this;
                return new Promise((resolve, reject) => {

                    let from = this.graphDateRange.from;
                    let to = this.graphDateRange.to;

                    var xfrom = new Date(from);
                    var xto = new Date(to);
                    
                    from = xfrom.toISOString().substring(0, 10);
                    to = xto.toISOString().substring(0, 10);

                    let getGraphDataParams = { from: from, to: to };

                    if (that.graphPage == 'reports' && g_campaignId)
                        getGraphDataParams.cm_id = g_campaignId;

                    Vue.$http.post(graphUrls.getGraphData[that.graphPage], getGraphDataParams).then((response) => {
                        if (response && response.data) {
                            resolve(response.data);
                        } else {
                            reject();
                        }
                    }).catch((error) => {
                        reject();
                    });

                });

            },

            setGraphDateRange(from, to) {

                var daysCount = this.getGraphDateRangeDaysCount(from, to);
                if (daysCount <= g_graphDateRangeDaysCount) {
                    this.graphDateRange = { from: from, to: to };
                }
                else {

                    if (this.graphTypes.length == 0) {
                        this.setGraphTypes(['Installs', 'Impressions']);
                    }

                }

                this.hideGraphAndGraphloader();

            },

            clearTableData() {
                this.tableData = this.tableData.splice(0, 0);
            },

            stringifyDate(date) {
                return [(date.getYear() + 1900) + "", ((date.getMonth() + 1) < 10 ? "0" : "") + (date.getMonth() + 1), (date.getDate() < 10 ? "0" : "") + date.getDate()].join("-");
            },

            setTableData(_g_tableData) {
                
                var fromDate = this.stringifyDate(g_filterSort.params.dateFrom);
                var toDate = this.stringifyDate(g_filterSort.params.dateTo);
                
                var daysCount = this.getGraphDateRangeDaysCount(fromDate, toDate);
                if (daysCount > g_graphDateRangeDaysCount) {
                    this.showTimePeriodOutOfRange();
                    return;
                }

                this.showGraphloader();
                this.tableData = _g_tableData;
            },

            hideGraphAndGraphloader() {
                this.hasNoGraphData = false;
                this.showGraph = false;
                this.isDataLoaded = false;
            },

            showGraphloader() {
                this.showGraph = false;
                this.isDataLoaded = true;
            },

            showTimePeriodOutOfRange() {
                this.hasNoGraphData = true;
                this.showGraph = false;
                this.isDataLoaded = false;

            },

            showGraphComponent() {
                this.showGraph = true;
                this.isDataLoaded = true;
            }

        },
        computed: {

            getGraphTotals() {

                var graphTotals = {
                    Installs: 0,
                    Impressions: 0,
                    Clicks: 0,
                    Cost: 0,
                    ConversionRate: 0,
                    eCPI: 0
                };
                
                if (this.all_data && this.hasNoGraphData == false) {


                    //graphTotals.ConversionRate = this.all_data['ConversionRate'] && this.all_data['ConversionRate'].length && this.all_data['ConversionRate'].filter(cr => cr !== 0).length ? this.all_data['ConversionRate'].reduce((total, amount) => total + amount, 0) / this.all_data['ConversionRate'].filter(cr => cr !== 0).length : 0;

                    
                    graphTotals.Installs = this.all_data['Installs'] && this.all_data['Installs'].length ? this.all_data['Installs'].reduce((total, amount) => total + amount) : 0;
                    graphTotals.Impressions = this.all_data['Impressions'] && this.all_data['Impressions'].length ? this.all_data['Impressions'].reduce((total, amount) => total + amount) : 0;
                    graphTotals.Clicks = this.all_data['Clicks'] && this.all_data['Clicks'].length ? this.all_data['Clicks'].reduce((total, amount) => total + amount) : 0;
                    graphTotals.ConversionRate = graphTotals.Clicks !== 0 ? 100 * graphTotals.Installs / graphTotals.Clicks : 0;
                    var temp_Cost = this.all_data['Cost'] && this.all_data['Cost'].length ? this.all_data['Cost'].reduce((total, amount) => total + amount) : 0;
                    graphTotals.Cost = temp_Cost.toFixed(2);
                    graphTotals.eCPI = (graphTotals.Installs > 0 ? temp_Cost / graphTotals.Installs : 0).toFixed(2);
                
                }
                
                return graphTotals;
            },

            getGraphData() {

                var displayedItemId = [];

                var dataKey = this.graphPage == 'reports' ? 'pba_id' : '_campaignid';   //  id of a row in db data

                displayedItemId = this.tableData.map(g => g[dataKey]);

                var _graphData = this.getLocalGraphData().filter(c => displayedItemId.indexOf(c.id) > -1);

                if (_graphData && _graphData.length > 0) {

                    var gData = {};
                    this.graphAllTypes.forEach((colName) => {

                        if (!gData[colName])
                            gData[colName] = [];

                        _graphData.forEach((d_item) => {

                            if (d_item.data[colName] === undefined) return;
                            d_item.data[colName].forEach((array_item, index, array) => {
                                if (gData[colName][index])
                                    gData[colName][index] += array_item;
                                else
                                    gData[colName][index] = array_item;
                            });
                        });
                    });
                    gData['ConversionRate'] = gData['Clicks'].map((x, i) => gData["Installs"][i] ? gData["Installs"][i] / gData['Clicks'][i] * 100 : 0);

                    this.all_data = gData;

                    var onlySelectedTypes = {};

                    this.graphTypes.forEach((colName) => {
                        if (!onlySelectedTypes[colName])
                            onlySelectedTypes[colName] = [];

                        onlySelectedTypes[colName] = this.all_data[colName]
                    });

                    return onlySelectedTypes;
                }

                return {};
            }

        },
        watch: {
            
            reportType(val) {
                // console.log('reportType(' + val + ')');
                document.getElementById('graph-discovery-manage').style.display = (val == 'Apps' && g_graphPage == 'reports') || (g_graphPage == 'manage') ? 'block' : 'none';
            },

            graphPage(val) {
                // console.log('graphPage(' + val + ')');
                document.getElementById('graph-discovery-manage').style.display = (g_filterSort.params.reportType == 'Apps' && val == 'reports') || (g_graphPage == 'manage') ? 'block' : 'none';
            },
            
            graphDateRange() {
                let that = this;
                this.graphData = this.graphData.splice(0, 0);

                this.hasNoGraphData = false;

                this.fetchGraphData().then((_data) => {

                    this.graphData = _data.map(function (c) {

                        var x = {};

                        // calculate conversion rate and add it to the data
                        let installsData = c.groupedData.filter(a => a.data_type == "Installs")[0].data.split(',').map(n => parseInt(n));
                        let clicksData = c.groupedData.filter(a => a.data_type == "Clicks")[0].data.split(',').map(n => parseInt(n));
                        let cr_data = clicksData.map((click, i, arr) => { return click == 0 ? 0 : 100 * installsData[i] / clicksData[i]; }).join(',');
                        let cr_data_id = c.groupedData[0].data_id;
                        let cr_data_type = "ConversionRate";

                        c.groupedData = [...c.groupedData, { data_id: cr_data_id, data_type: cr_data_type, data: cr_data }];

                        c.groupedData.forEach(function (d) {
                            x[d.data_type] = JSON.parse('[' + d.data + ']');
                        });
                                                
                        return {
                            id: c.id,
                            data: x
                        }
                    });



                    this.hasNoGraphData = (this.graphData.length == 0);

                });
            },

            all_data() {

                this.showGraphComponent();

            }

        },
        created() {

            var gtypes = JSON.parse(localStorage.getItem("reportsGraph_graphSelectedTypes"));
            this.graphTypes = gtypes && gtypes.length > 0 ? gtypes : ['Installs', 'Impressions'];

        }
    });

}
else {

    if (document.getElementById('graph-discovery-manage') != null)
        document.getElementById('graph-discovery-manage').style.display = 'none';

}

// Request
//axios.interceptors.request.use(

//    config => {

//        return config;
//    },
//    error => {
//        Promise.reject(error);
//    }
//);

// Response
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const originalRequest = error.config;

        if (error.response.status === 401) {
            if (originalRequest.url != "/publisher/service.asmx/getPublisherListByQuery") {
                location.href = "//www.appnext.com/sign-in";
            }
        }

        return Promise.reject(error);
    }
);

Vue.directive('init', {
    bind: function (el, binding) {
        el.value = binding.value || null;
    }
});



// WEBPACK FOOTER //
// ./src/main.js